"use strict";

exports.__esModule = true;
exports.makeBehaviorRelatedProps = void 0;
var _dataset = require("../../entities/dataset");
const makeBehaviorRelatedProps = (connection, dataset) => {
  const behaviorRelatedProps = [];
  for (const [name, behaviorDescriptor] of Object.entries(connection.behaviors)) {
    var _behaviorRelatedPropS;
    const behaviorRelatedPropEntry = (_behaviorRelatedPropS = behaviorRelatedPropSetters[name]) == null ? void 0 : _behaviorRelatedPropS.call(behaviorRelatedPropSetters, behaviorDescriptor, dataset);
    if (behaviorRelatedPropEntry != null && behaviorRelatedPropEntry.length) {
      behaviorRelatedProps.push(behaviorRelatedPropEntry);
    }
  }
  return behaviorRelatedProps;
};
exports.makeBehaviorRelatedProps = makeBehaviorRelatedProps;
const behaviorRelatedPropSetters = {
  input: ({
    disabled: disabledProp
  }, dataset) => _dataset.Dataset.isReadonly(dataset) ? [disabledProp, true] : [],
  click: ({
    action,
    disabled: disabledProp
  }, dataset) => action === 'next' && !_dataset.Dataset.hasNextRecord(dataset) || action === 'previous' && !_dataset.Dataset.hasPrevRecord(dataset) ? [disabledProp, true] : []
};
//# sourceMappingURL=make-behavior-related-props.js.map